export default function IconUser() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g id="Grupo_2592" data-name="Grupo 2592" transform="translate(-1548 -7)">
        <circle
          id="Elipse_183"
          data-name="Elipse 183"
          cx="24"
          cy="24"
          r="24"
          transform="translate(1548 7)"
          fill="#93a1a4"
        />
        <g
          id="Grupo_2593"
          data-name="Grupo 2593"
          transform="translate(1560 19)"
        >
          <path
            id="Caminho_5146"
            data-name="Caminho 5146"
            d="M0,0H24V24H0Z"
            fill="none"
          />
          <path
            id="Caminho_5147"
            data-name="Caminho 5147"
            d="M4,22a8,8,0,0,1,16,0H18A6,6,0,0,0,6,22Zm8-9a6,6,0,1,1,6-6A6,6,0,0,1,12,13Zm0-2A4,4,0,1,0,8,7,4,4,0,0,0,12,11Z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}
